var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.assetInfos),function(item){return _c('upload-file',{key:item.FileName,attrs:{"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }